import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import warningIcon from "@icons/ic-warning.svg";
import {
  renderPriceWithCurrency,
  addSpace,
  renderPriceWithCurrencyWithoutUnit,
} from "@utils/utils";
import {
  GridRow,
  HorizontalRow,
  GridSubLabel,
  GridItem,
  GridSubItem,
  IconGridItem,
} from "./SiteFollowUp.styled";
import "../../SiteView.scss";

const QuoteItems = (props) => {
  const {
    t,
    itemList,
    serviceStatus,
    currency,
    siteNeedKickoff,
    exchangeRates,
    serviceCurrency,
  } = props;

  const getConvertedPrice = (currencyId, price) => {
    const rateInfo = exchangeRates?.find(
      (rate) => rate.currencyFrom === currencyId
    );
    return rateInfo ? rateInfo?.exchangeRate * price : price;
  };

  return (
    <>
      {itemList?.length > 0 &&
        itemList.map((item, itemIndex) => {
          return (
            <React.Fragment key={"site-follow-up-item" + item?.id + itemIndex}>
              {itemIndex !== 0 && <HorizontalRow />}

              <GridRow
                column={
                  parseInt(item?.koStatus, 10) === 0 && siteNeedKickoff === 1
                    ? "3% 37% 15% 15% 15% 15%"
                    : "40% 15% 15% 15% 15%"
                }
                marginBottom="0px"
                gridGap="0rem"
                marginTop="0px"
                borderBottom={
                  itemList.length === parseInt(itemIndex, 10) + 1
                    ? "2px solid rgba(10, 73, 134, 0.3)"
                    : "0px solid rgba(10, 73, 134, 0.3)"
                }
              >
                {parseInt(item?.koStatus, 10) === 0 && siteNeedKickoff === 1 && (
                  <IconGridItem
                    backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}
                    borderLeft="2px solid rgba(10, 73, 134, 0.3)"
                    borderRight="0px solid rgba(10, 73, 134, 0.3)"
                    marginTop="15px"
                    width="25px"
                    padding="0px"
                  >
                    <Image
                      className="site-view-enquiry__quote-icon"
                      src={warningIcon}
                      title={t("SITE_FOLLOWUP_WARNING_NOT_VALIDATED")}
                      alt={t("SITE_FOLLOWUP_WARNING_NOT_VALIDATED")}
                    />
                  </IconGridItem>
                )}
                <GridItem
                  backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}
                  borderLeft={
                    parseInt(item?.koStatus, 10) === 0 || siteNeedKickoff !== 1
                      ? "0px solid rgba(10, 73, 134, 0.3)"
                      : "2px solid rgba(10, 73, 134, 0.3)"
                  }
                  borderRight="2px solid rgba(10, 73, 134, 0.3)"
                >
                  <GridRow column="70% 30%" marginBottom="0px" marginTop="0px">
                    <GridSubLabel
                      color="#0A4986;
"
                    >
                      {String(item?.label) || ""}
                    </GridSubLabel>
                    <GridSubItem
                      color="#474747"
                      fontSize="16px"
                      fontWeight="700"
                      textAlign="center"
                      fontStyle="normal"
                    >
                      {renderPriceWithCurrency(
                        item?.price
                          ? addSpace(
                              getConvertedPrice(
                                serviceCurrency?.id,
                                item?.price
                              )
                            )
                          : "",
                        t(item?.unit),
                        currency?.symbol,
                        currency?.position
                      )}
                    </GridSubItem>
                  </GridRow>

                  <GridRow column="70% 30%" marginBottom="0px" marginTop="0px">
                    <GridSubItem
                      color="#474747"
                      fontSize="14px"
                      fontStyle="italic"
                    >
                      {item.hesusService.needProduct && item.product.name}

                      {item.hesusService.needProduct &&
                        item.hesusService.needTransport &&
                        " - "}
                      {item.hesusService.needTransport && item.transport.name}
                    </GridSubItem>
                    <GridSubItem
                      color="#474747"
                      fontSize="14px"
                      fontWeight="400"
                      textAlign="center"
                      fontStyle="italic"
                    >
                      {item.quantity + " " + t(item?.unit)}
                    </GridSubItem>
                  </GridRow>
                  {/* </GridRow> */}
                </GridItem>
                <GridItem backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}>
                  <GridSubItem
                    color="#474747"
                    fontSize="16px"
                    fontWeight="700"
                    textAlign="center"
                    fontStyle="normal"
                  >
                    {item.ordered + " " + t(item?.unit)}
                  </GridSubItem>
                </GridItem>
                <GridItem backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}>
                  <GridSubItem
                    color="#474747"
                    fontSize="16px"
                    fontWeight="700"
                    textAlign="center"
                    fontStyle="normal"
                  >
                    {item.planned + " " + t(item?.unit)}
                  </GridSubItem>
                </GridItem>
                <GridItem backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}>
                  <GridSubItem
                    color="#474747"
                    fontSize="16px"
                    fontWeight="700"
                    textAlign="center"
                    fontStyle="normal"
                  >
                    {item.realised !== null
                      ? item.realised + " " + t(item?.unit)
                      : "-"}
                  </GridSubItem>
                </GridItem>
                <GridItem backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}>
                  <GridSubItem
                    color="#474747"
                    fontSize="16px"
                    fontWeight="700"
                    textAlign="center"
                    fontStyle="normal"
                  >
                    {renderPriceWithCurrencyWithoutUnit(
                      item?.price
                        ? addSpace(
                            getConvertedPrice(
                              serviceCurrency?.id,
                              item?.turnover
                            )
                          )
                        : "",
                      currency?.symbol,
                      currency?.position
                    )}
                  </GridSubItem>
                </GridItem>
              </GridRow>
            </React.Fragment>
          );
        })}
    </>
  );
};

QuoteItems.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
QuoteItems.defaultProps = {
  id: null,
};

export default withTranslation()(QuoteItems);
